module.exports = {
  data() {
    return {
      customModalOpt: {
        title: '操作',
        contentTips: '是否确定如此操作'
      }
    }
  },
  methods: {
    // 弹窗调用前的传参处理
    beforeShowModal(v, params) {
      // 设定去处
      const ref = this.$refs.modal
      if (!ref) return
      ref.handlerVisible(v, params)
    },
    // 处理弹窗的ok回调
    handlerOk() {
      const ref = this.$refs.modal
      if (!ref) return
      const { source, params } = ref.sourceOptions
      if (this[source]) {
        this[source](params)
      }
    }
  }
}